<div class="section instructions p-0">
  <h5>{{ task.instructionsTitle }}</h5> <p [innerHTML]="task.instructions"></p>

  <a
    [routerLink]="['/appointments/new']"
    *ngIf="task.content.appointmentNeeded"
    class="btn btn-lg btn-primary btn-block"
  >
    Book Visit
  </a>
  <hr />
</div>

<div class="section order-details p-0">
  <h5 [ngPlural]="task.content.numberOfTests">
    <ng-template ngPluralCase="=0">No Tests Ordered</ng-template>
    <ng-template ngPluralCase="=1">1 Test Ordered</ng-template>
    <ng-template ngPluralCase="other">{{ task.content.numberOfTests }} Tests Ordered</ng-template>
  </h5>
  <ul>
    <li *ngFor="let test of task.content.testsOrdered">{{ test }}</li>
  </ul>
</div>

<div>
  <h5>{{ task.taskOptionsTitle }}</h5> <p>{{ task.taskOptionsDescription }}</p>
</div>
